module.exports = __webpack_public_path__ + "img/ROUND SHADES GREEN.5fefd1e.svg";